import getDeleteItemConfirmation from '../tnew/handlers/getDeleteItemConfirmation';
import ajax from '../utils/ajax';

export type OnCompleteCallbackArgs = { redirectTo: string, closeModal?: () => void };
export type OnCompleteCallback = (data: OnCompleteCallbackArgs) => void;

const attributes = {
  deleteUrl: 'data-tn-delete-url',
};

class DeleteCartItemButton {
  constructor(
    private $el: HTMLButtonElement,
    private onComplete: OnCompleteCallback,
  ) {
    $el.addEventListener('click', this.removeItem);
  }

  removeItem = async () => {
    const messageType = this.$el.getAttribute('data-tn-message-type') || '';

    const modalTitle = this.$el.getAttribute('data-tn-remove-item-confirmation-modal-title') || '';

    const { isConfirmed, closeModal } = await getDeleteItemConfirmation({ messageType, modalTitle, $content: undefined });

    if (!isConfirmed) {
      return;
    }

    const url = this.$el.getAttribute(attributes.deleteUrl);

    let redirectTo = window.location.href;

    try {
      const customizationPointUrl = await ajax.post(url);

      if (customizationPointUrl) {
        redirectTo = customizationPointUrl;
      }
    } catch (e) {
    }

    this.onComplete({ redirectTo, closeModal });
  };

  setDeleteUrl(value: string) {
    this.$el.setAttribute(attributes.deleteUrl, value);
  }
}

export default DeleteCartItemButton;
